import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

const object = vnObject

const mailForm = $('.js-mail-form')

if (mailForm.length) {
    mailForm.parsley().on('form:success', function () {
        mailForm.attr('data-success', 'true')
    })

    mailForm.parsley().on('form:error', function () {
        mailForm.attr('data-success', 'false')
    })

    mailForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(mailForm[0])
        formData.append('action', 'vn_update_mail')
        formData.append('nonce', object.nonce)

        const $mailForm = mailForm
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $mailForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $mailForm.removeClass('sending')

                Alert(res.success, res.data.message)
            },
        })
    })
}

const passwordForm = $('.js-password-form')

if (passwordForm.length) {
    passwordForm.parsley().on('form:success', function () {
        passwordForm.attr('data-success', 'true')
    })

    passwordForm.parsley().on('form:error', function () {
        passwordForm.attr('data-success', 'false')
    })

    passwordForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(passwordForm[0])
        formData.append('action', 'vn_update_password')
        formData.append('nonce', object.nonce)

        const $passwordForm = passwordForm
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $passwordForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $passwordForm.removeClass('sending')

                Alert(res.success, res.data.message)
                res.success && $passwordForm[0].reset()
                location.reload()
            },
        })
    })
}